import "client-only";
import useSWR from "swr";
import { fetcher } from "../../utils/fetcher";
function useWareHouseList(params) {
  return useSWR(
    !!params
      ? {
          path: `/api/v1/warehouses`,
          method: "GET",
          params,
        }
      : null,
    fetcher,
    {
      revalidateOnFocus: true,
      revalidateOnMount: true,
    },
  );
}

export default useWareHouseList;
